import {
  iconConvertible,
  iconConvertibleSymbol,
  iconCoupe,
  iconCoupeSymbol,
  iconEv,
  iconEvSymbol,
  iconHatchback,
  iconHatchbackSymbol,
  iconHybrid,
  iconHybridSymbol,
  iconMinivan,
  iconMinivanSymbol,
  iconSedan,
  iconSedanSymbol,
  iconSuv,
  iconSuvSymbol,
  iconTruck,
  iconTruckSymbol,
  iconWagon,
  iconWagonSymbol,
} from 'client/images/inline-svgs/ads/type-v2-icons-svgs';

export const ICON_MAP = {
  electric: iconEv,
  hybrid: iconHybrid,
  convertible: iconConvertible,
  sedan: iconSedan,
  truck: iconTruck,
  hatchback: iconHatchback,
  wagon: iconWagon,
  minivan: iconMinivan,
  coupe: iconCoupe,
  suv: iconSuv,
  default: iconSedan,
};

export const SYMBOL_MAP = [
  iconEvSymbol,
  iconHybridSymbol,
  iconConvertibleSymbol,
  iconSedanSymbol,
  iconTruckSymbol,
  iconHatchbackSymbol,
  iconWagonSymbol,
  iconMinivanSymbol,
  iconCoupeSymbol,
  iconSuvSymbol,
];
